<template>
  <v-form v-model="valid">
    <v-container fluid grid-list-lg>
      <v-layout wrap>
        <v-flex lg4 sm6 xs12>
          <v-text-field
            label="Empleador"
            v-model="value.empleador"
            v-validate="'required|max:100'"
            required
            data-vv-name="empleador"
            :error-messages="errors.collect('empleador')"
            append-outer-icon="search"
            @click:append-outer="buscarEmpleadorPorNombre()"
          ></v-text-field>
        </v-flex>

        <v-flex lg4 sm6 xs12>
          <v-text-field
            label="Cuit"
            v-model="value.cui"
            mask="##-########-#"
            clearable
            v-validate="'required'"
            required
            data-vv-name="cuit del empleador"
            :error-messages="errors.collect('cuit del empleador')"
            append-outer-icon="search"
            @click:append-outer="buscarEmpleadorPorCui()"
          ></v-text-field>
        </v-flex>

        <v-flex lg4 class="hidden-md-and-down"> </v-flex>

        <v-flex lg2 sm6 xs12>
          <v-text-field
            label="Cargo"
            v-model="value.cargo"
            data-vv-name="cargo"
          ></v-text-field>
        </v-flex>

        <v-flex lg2 sm6 xs12>
          <v-text-field
            label="Sección"
            v-model="value.seccion"
            data-vv-name="sección"
          ></v-text-field>
        </v-flex>

        <v-flex lg4 sm6 xs12>
          <v-autocomplete
            v-model="value.actividadLaboralId"
            :items="listActividadesLaborales"
            item-text="descripcion"
            item-value="id"
            label="Actividad"
            :menu-props="{ minWidth: '200' }"
          ></v-autocomplete>
        </v-flex>

        <v-flex lg4 class="hidden-md-and-down"> </v-flex>

        <v-flex lg2 sm6 xs12>
          <v-text-field
            label="Nº Legajo"
            v-model="value.legajo"
            data-vv-name="legajo laboral"
          ></v-text-field>
        </v-flex>

        <v-flex lg2 sm6 xs12>
          <v-text-field
            label="Fecha Ingreso"
            v-model="value.fechaIngreso"
            type="date"
            v-validate="'required'"
            data-vv-name="fecha de ingreso"
            :error-messages="errors.collect('fecha de ingreso')"
          ></v-text-field>
        </v-flex>

        <v-flex lg2 sm6 xs12>
          <v-text-field
            label="Jefe"
            v-model="value.jefe"
            data-vv-name="jefe/supervisor"
          ></v-text-field>
        </v-flex>

        <v-flex lg2 sm6 xs12>
          <v-text-field
            label="Horario"
            v-model="value.horario"
            data-vv-name="horario laboral"
          ></v-text-field>
        </v-flex>

        <v-flex lg4 class="hidden-md-and-down"> </v-flex>

        <v-flex lg2 sm6 xs12>
          <v-text-field
            label="Ingreso Neto"
            v-model="value.ingresoNeto"
            data-vv-name="igreso neto"
          ></v-text-field>
        </v-flex>

        <v-flex lg2 sm6 xs12>
          <v-autocomplete
            v-model="value.diaCobroId"
            :items="listDiasCobro"
            item-text="descripcion"
            item-value="id"
            label="Día de Cobro"
            :disabled="!checkCanAccess('ap-modifica-dia-cobro')"
            :menu-props="{ minWidth: '200' }"
          ></v-autocomplete>
        </v-flex>

        <v-flex lg2 sm6 xs12>
          <v-autocomplete
            v-model="value.formaCobroId"
            :items="listFormasCobro"
            item-text="descripcion"
            item-value="id"
            label="Forma Cobro"
            :menu-props="{ minWidth: '200' }"
          ></v-autocomplete>
        </v-flex>

        <v-flex lg4 sm6 xs12>
          <v-text-field
            label="Email"
            v-model="value.email"
            browser-autocomplete="disabled"
            data-vv-name="email laboral"
          ></v-text-field>
        </v-flex>

        <v-flex xs12>
          <app-manejo-telefonos
            propName="telefonos"
            :value="value"
            label="Teléfonos Laborales"
          ></app-manejo-telefonos>
        </v-flex>

        <v-flex>
          <v-layout>
            <v-flex>
              <app-manejo-domicilios
                propName="domicilios"
                :value="value"
              ></app-manejo-domicilios>
            </v-flex>
          </v-layout>
        </v-flex>

        <!-- Lista de Empleadores x Nombre -->
        <app-lista-busqueda
          label="Búsqueda de Empleadores Por Nombre"
          :visible.sync="listaEmpleadoresPorNombreVisible"
          v-on:update:visivility="listaEmpleadoresPorNombreVisible = $event"
          :headers="[
            { text: 'Nombre', value: 'nombre' },
            { text: 'CUIT/L', value: 'cui' },
          ]"
          searchApi="empleadores"
          :searchFor="'descripcion=' + value.empleador"
          :setSelectedItem="setEmpleadorBusqueda"
        ></app-lista-busqueda>

        <!-- Lista de Empleadores x Cui -->
        <app-lista-busqueda
          label="Búsqueda de Empleadores Por CUIL/T"
          :visible.sync="listaEmpleadoresPorCuiVisible"
          v-on:update:visivility="listaEmpleadoresPorCuiVisible = $event"
          :headers="[
            { text: 'Nombre', value: 'nombre' },
            { text: 'CUIT/L', value: 'cui' },
          ]"
          searchApi="empleadores/listarporcui"
          :searchFor="'cui=' + value.cui"
          :setSelectedItem="setEmpleadorBusqueda"
        ></app-lista-busqueda>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import Vue from 'vue';
import { http } from '@/axios';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      valid: false,
      loading: false,
      listaEmpleadoresPorNombreVisible: false,
      listaEmpleadoresPorCuiVisible: false,
      listActividadesLaborales: [],
      listDiasCobro: [],
      listFormasCobro: [],
      listSexos: [],
      listEstadosCiviles: [],
    };
  },
  props: {
    value: {
      type: Object,
      required: false,
      default: function() {
        return {
          empleador: '',
          cuit: 0,
          cargo: '',
          seccion: '',
          jefe: '',
          horario: '',
          fechaIngreso: 0,
          legajo: '',
          estadoCivilId: 1,
          diaCobroId: 1,
          formaCobroId: 1,
          email: '',
        };
      },
    },
    editMode: {
      type: Boolean,
      default: true,
    },
  },
  created() {
    this.loadActividadesLaborales();
    this.loadFormasCobro();
    this.loadDiasCobro();
  },
  computed: {
    ...mapGetters(['user', 'DebugModeOn', 'checkCanAccess']),
  },
  watch: {
    'value.nombre': function() {
      this.value.nombre = this.value.nombre.toUpperCase();
    },
    'value.apellido': function() {
      this.value.apellido = this.value.apellido.toUpperCase();
    },
  },
  methods: {
    async loadActividadesLaborales() {
      this.loading = true;
      try {
        var result = await http.get('tiposactividadlaboral'); // traigo todas
        this.listActividadesLaborales = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
    async loadDiasCobro() {
      this.loading = true;
      try {
        var result = await http.get('tiposdiacobro'); // traigo todas
        this.listDiasCobro = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
    async loadFormasCobro() {
      this.loading = true;
      try {
        var result = await http.get('tiposformacobro'); // traigo todas
        this.listFormasCobro = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
    async buscarEmpleadorPorNombre() {
      this.listaEmpleadoresPorNombreVisible = true;
    },
    async buscarEmpleadorPorCui() {
      this.listaEmpleadoresPorCuiVisible = true;
    },
    setEmpleadorBusqueda(empleador) {
      console.log(empleador);

      this.value.empleador = empleador.nombre;
      this.value.cui = empleador.cui;
      this.value.diaCobroId = empleador.diaCobroId;
      this.value.actividadLaboralId = empleador.tipoActividadLaboralId;
    },
  },
};
</script>
